import "../../new.scss";
import { useParams, useNavigate } from 'react-router-dom';
import { useState, useContext, useEffect, useRef } from "react";
import { ListasCabFormContext } from '../../../context/listascab/ListasCabContext';
import { ListasDetState } from '../../../context/listasdet/ListasDetState';
import DatatableDetalle from './listasdet/DatatableDetalle';
import ConfirmationDialog from "../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDialog";
import FormField from "../../../components/FormField/FormField";
import FormButtons from "../../../components/FormButtons/FormButtons";
import Inputs from "./configForm/inputs";
import { handleInputChange } from "./helpersForm/formHandlers";
import CategoriasModal from '../../categoriasCliente/categoriasClienteModal/categoriasClienteModal';

export const Form = ({ title }) => {
  const [form, setForm] = useState({});
  const {
    report,
    postListaData, // Asegúrate que estas funciones están bien definidas en tu contexto
    patchListaData,
    detalleListaData,
    addItemToArray,
    getItemFromArrayById,
    updateItemFromArray,
    removeItemFromArray,
    clearArray
  } = useContext(ListasCabFormContext);
  const { id } = useParams();
  const navigate = useNavigate(); 
  // Manejo de errores
  const [errors, setErrors] = useState({});

  // Estado de envío (isSubmitting) para mostrar el estado de carga
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Estado del formulario
  const [isFormFilled, setIsFormFilled] = useState(false); // Nuevo estado
  // Estado del detalle
  const [isDetalleFilled, setIsDetalleFilled] = useState(false); // Nuevo estado

  // Estado para controlar la apertura de los diálogos
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Estados para filtros
  const [searchIdCategoria, setSearchIdCategoria] = useState();
  const [searchDescCategoria, setSearchDescCategoria] = useState('');

  const nameData = "listas";
  const saveData = postListaData;
  const updateData = patchListaData;
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date 
  };

  useEffect(() => {
    if (report && Object.keys(report).length > 0) {
      setForm({
        ...report,
        lp_descripcion: String(report.lp_descripcion), 
        lp_porc: report.lp_porc !== null ? String(report.lp_porc) : "",
      }
      )
      setSearchIdCategoria(report.lp_tipo_precio || "");
      if (report.lp_tipo_precio === 0) {
        setSearchDescCategoria("Mayorista");
      }
       if (report.lp_tipo_precio === 1) {
        setSearchDescCategoria("Minorista");
      }
      if (report.lp_tipo_precio === 2) {
        setSearchDescCategoria("Costo");
      }
      else
        setSearchDescCategoria("Minorista");
      ;
      setIsFormFilled(true)
    }
  }, [report]);

  useEffect(() => {
    setIsSubmitting(false);

     if (searchIdCategoria !== null && searchIdCategoria !== undefined) {
      setForm((prevForm) => ({
        ...prevForm,
        lp_tipo_precio: searchIdCategoria,
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        lp_tipo_precio: null,
      }));
    } else if (!searchDescCategoria) {
      setSearchIdCategoria(null); 
      setForm((prevForm) => ({
        ...prevForm,
        lp_tipo_precio: null,
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        lp_tipo_precio: "", 
      }));
    }
  }, [searchDescCategoria, searchIdCategoria]);

  useEffect(() => {
    const isFilled = Inputs(id).every(({ name }) => {
      const value = form[name];
      return value !== null && value !== undefined && value !== "";
    });
    const hasErrors = Object.values(errors).some(value => value !== null && value !== "");
    setIsFormFilled(isFilled && !hasErrors);
  }, [form, errors, id]); // Dependemos de `form`, `errors` y `id`
 

  const handleChange = (e) => {
    handleInputChange(e, setForm, Inputs(id), setErrors, form);
  };


  const validateForm = () => {
    let formErrors = {};

    // Validar los campos del formulario
    Inputs(id).forEach(({ name, validation }) => {
      if (validation) {
        const error = validation(form[name] || "", form);
        if (error) {
          formErrors[name] = error;
        }
      }
    });

    // Verificar si el tamaño de `detalle` es 0
    if (detalleListaData.length === 0 && !id) {
      formErrors.detalle = "La lista no puede estar vacía. Agregue al menos un articulo.";
    }
    setErrors(formErrors);
    return !Object.keys(formErrors).length;
  };

  const openConfirmDialog = () => setIsConfirmDialogOpen(true);
  const closeConfirmDialog = () => setIsConfirmDialogOpen(false);

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };

  const closeErrorDialog = () => setIsErrorDialogOpen(false);

  const handleSendData = () => {
    if (!validateForm()) {
      setErrors((prevErrors) => {
        const errorMessagesArray = Inputs(id).reduce((acc, { name, label }) => {
          if (prevErrors[name]) {
            const fieldLabel = label || name; 
            acc.push(`${fieldLabel}: ${prevErrors[name]}`);
          }
          return acc;
        }, []);
        
        if (errors.detalle) {
          errorMessagesArray.push(`Articulos: ${errors.detalle}`);
        }
      
        if (errorMessagesArray.length > 0) {
          openErrorDialog(errorMessagesArray || "por favor verifique os errores");
        }

        return prevErrors; 
      });

      return;
    }
    openConfirmDialog();
  };

  const confirmSendData = async () => {
    setIsSubmitting(true);
    closeConfirmDialog();

    try {
      if (id) {
        await updateData(id, form);
      } else {
        await saveData(form);
      }
      navigate(`/${nameData}`);
    } catch (error) {
      console.error(error);
      openErrorDialog("Error al guardar los datos. Intenta nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(`/${nameData}`);
  };
 
  
  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <form>
              {Inputs(id).map((input) => {
                if (input.name === "lp_tipo_precio") {
                  return (
                    <div className="formInput" key={input.id}>
                      <label>{input.label}</label>
                      <CategoriasModal
                        handleIDChange={setSearchIdCategoria}
                        handleDescChange={setSearchDescCategoria}
                        descSelected={searchDescCategoria}
                        isEditing={id}
                      />
                      {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                    </div>
                  );
                }
                else {
                  return (
                    <FormField
                      key={input.id}
                      input={input}
                      placeholder={input.placeholder}
                      value={form[input.name] ?? ""}
                      handleInputChange={(e) => handleChange(e)}
                      error={errors[input.name]}
                    />
                  );
                }

              })}
              <FormButtons
                isSubmitting={isSubmitting}
                handleSave={handleSendData}
                handleCancel={handleCancel}
                saveText="Guardar"
                cancelText="Cancelar"
                isSaveDisabled={detalleListaData.length === 0&& !id}
              />

            </form>

            <ListasDetState >
              <DatatableDetalle
                lpid={id} 
                tipoprecio={form.lp_tipo_precio}
                arrayDetalle={detalleListaData}
                addItem={addItemToArray}
                getItem={getItemFromArrayById}
                updateItem={updateItemFromArray}
                removeItem={removeItemFromArray}
                clearArray={clearArray}
                isCabComplete={isFormFilled}
                setIsDetalleFilled={setIsDetalleFilled}
              />
            </ListasDetState>
            <ConfirmationDialog
              isOpen={isConfirmDialogOpen}
              onClose={closeConfirmDialog}
              onConfirm={confirmSendData}
              title=""
              message="¿Estás seguro de que deseas guardar este registro?"
            />
            <ErrorDialog
              isOpen={isErrorDialogOpen}
              onClose={closeErrorDialog}
              messages={errorMessage}
              title=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
